import { Repository } from "src/firebase/firestore/repository";
import { BookingCancellationEntity } from "../types/booking.entity";

class BookingCancellationRepository extends Repository<BookingCancellationEntity> {
  constructor() {
    super("booking_cancellations");
  }
}

export const bookingCancellationRepository = new BookingCancellationRepository();


